import { render, staticRenderFns } from "./PorcentajeMantenimiento.vue?vue&type=template&id=b28fc80c&"
import script from "./PorcentajeMantenimiento.vue?vue&type=script&lang=js&"
export * from "./PorcentajeMantenimiento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports